import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { liveCleanroom } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from 'react-query';


export const useGetLiveCleanRoomDataset = (lcrId) => {
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);

  return useQuery(
    ['liveCleanroomDatasets', lcrId],
    () => axiosInstance.get(liveCleanroom(orgId).getLcrDatasets(lcrId)),
    {
      select: (response) => response.data?.liveCleanRoomDatasetDetails || [],
      onError: (error) => {
        dispatch(showAlert({
          message: error.response?.data?.message ?? 'Error fetching live cleanroom dataset',
          type: 'error',
        }));
      },
    },
  );
};
